import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery } from '@coolblue-development/freddy';
import { freddyTheme as theme } from '@coolblue-development/freddy/theme/config';
import { getBannerDimensionsForZone } from '../../../../utils/index.js';
import { DynamicAdSlot } from './DynamicAdSlot.js';
import { FallbackAdSlot } from './FallbackAdSlot.js';
export const AdSlot = ({ kevelAd, imageSizes }) => {
    var _a, _b;
    const isMediumBreakpointOrUp = useMediaQuery(theme.breakpoint.minWidth('md'));
    const adType = kevelAd.content.__typename;
    const { mobile, desktop } = getBannerDimensionsForZone(kevelAd.zone);
    return (_jsxs(_Fragment, { children: [adType === 'DynamicAdContent' && _jsx(DynamicAdSlot, { content: kevelAd.content.body }), adType === 'FallbackAdContent' && (_jsx(FallbackAdSlot, { imageId: isMediumBreakpointOrUp
                    ? (_a = kevelAd.content.desktopImage) === null || _a === void 0 ? void 0 : _a.id
                    : (_b = kevelAd.content.mobileImage) === null || _b === void 0 ? void 0 : _b.id, imageSizes: imageSizes, imageDimensions: { ...(isMediumBreakpointOrUp ? desktop : mobile) }, altText: kevelAd.content.altText }))] }));
};
//# sourceMappingURL=AdSlot.js.map